import React, { useRef, useState } from "react";
import { Button } from "react-bootstrap";
import "../styles/components/Search.scss";
import Modal from "react-bootstrap/Modal";
import AdvanceSearch from "./AdvanceSearch";
import { MobileView } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { PAGE } from "../constants/page";
import SuggestionList from "./SuggestionList";
import { Trans } from "react-i18next";
import i18next from "i18next";
import { useAuth } from "react-oidc-context";
import Utility from "../utility/Utility";
import ErrorBoundaryHandler from "./ErrorBoundaryHandler";
import { updateSearchStatus } from "../redux/reducers/PatientSlice";
import { useAppDispatch } from "../redux/hooks";

const Search = (props: any) => {
  const placeholderStr = i18next.t(`placeholder.search_beneficiary`);
  const navigate = useNavigate();
  const [advanceSearch, showAdvanceSearch] = useState(false);
  const auth = useAuth();
  const inputRef = useRef<HTMLInputElement>(null);
  const dispatch = useAppDispatch();

  const handleAdvancedSearchClick = (e: any) => {
    dispatch(updateSearchStatus(true));
    e.preventDefault();
    showAdvanceSearch(true);
  };

  const handleKeyDown = (e: any) => {
    dispatch(updateSearchStatus(false));
    const search = inputRef?.current?.value;
    if (e?.code === "Enter" || e?.key === "Enter" || e?.keyCode === 13) {
      if (search && search?.length >= 3) {
        inputRef?.current.blur();
        props.onSearch(search);
      }
    }
  };

  const handleOnInput = (e: any) => {
    const searchQuery = Utility.englishOnlyWithSpecialCharacterForSearch(e);
    props.onInput(searchQuery?.toString().trim());
  };

  const handleCloseClick = () => {
    showAdvanceSearch(false);
  };

  const handleSearchClick = (searchPatient: any) => {
    props.onSearch(searchPatient);
    showAdvanceSearch(false);
  };

  const handleSuggestionSelect = (searchPatient: any) => {
    if (searchPatient === "view all") {
      const search = (
        document.getElementById("searchInput") as HTMLInputElement
      )?.value;
      props.onSearch(search);
    } else {
      navigate(PAGE.VIEW_PATIENT_DETAILS.replace(":id", searchPatient.id));
    }
  };

  const handleSearchIconClick = () => {
    const search = inputRef?.current?.value;
    if (search && search?.length >= 3) {
      inputRef?.current.blur();
      props.onSearch(search);
    }
  };

  return (
    <div className="search p-3">
      <h1 className="homeHeading">
        <Trans i18nKey={"welcome"}></Trans>{" "}
        {auth?.user?.profile.given_name || ""}
      </h1>
      <div className="searchImgInput">
        <input
          id="searchInput"
          type={"search"}
          placeholder={placeholderStr}
          onKeyDown={handleKeyDown}
          onInput={handleOnInput}
          onChange={Utility.englishOnlyWithSpace}
          ref={inputRef}
          maxLength={100}
        />
        <img
          className="search-icon"
          src="/icons/gizmo-search.svg"
          alt="search icon"
          onClick={handleSearchIconClick}
        />
      </div>
      {/*TODO: below code is for quick suggestion it can be activated while ApI wiring */}

      <SuggestionList onSelect={handleSuggestionSelect} />

      <div className="advSearchLabel">
        <a
          href={""}
          className="advancedSearchLabel"
          data-testid="showadvancesearch"
          onClick={handleAdvancedSearchClick}
        >
          <Trans i18nKey={"advanced_search"}></Trans>
        </a>
        <MobileView>
          <Modal show={advanceSearch}>
            <div className="text-end">
              <div className="img-close" onClick={handleCloseClick}>
                <img width="24" height="24" src="/icons/close.svg"></img>
              </div>
            </div>
            <AdvanceSearch
              onSearchClick={handleSearchClick}
              onCloseClick={handleCloseClick}
            />
          </Modal>
        </MobileView>
      </div>
    </div>
  );
};

export default ErrorBoundaryHandler(Search);
